import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Container } from "react-bootstrap";
// import "./LoginStyle.css";
import lockIcon from "../../2.Commons/lock.png";
import { postLogin,updateLogin, getRoles } from "../../3.Store/LoginSlice";
import { ThreeDots } from "react-loader-spinner"; // <-- Add this

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { login } = useSelector((state) => state.LoginSlice);
  const { username, password } = login;

  const [loading, setLoading] = useState(false); // <-- Local loading state

  useEffect(() => {   
    if (localStorage.getItem('current_user')) {
      navigate('/');
    }
  }, []);

  const handleChangeForm = (e) => {
    const entity = { ...login, [e.target.name]: e.target.value };
    dispatch(updateLogin(entity));
  };

  const handleForgotPassword = () => {
    Swal.fire({
      icon: "info",
      title: "Please contact IT Department",
      // confirmButtonColor: "#9fcad6",
    });
  };

  // Handle login submission
  const handleLogin = (e) => {
    // e.preventDefault();
    if (e) {
      e.preventDefault(); // Prevent default form submission if event is passed
    }
    const entity = { ...login };
    setLoading(true); // <-- Start loading
    dispatch(postLogin(entity))
      .unwrap()
      .then((data) => {
        console.log(data)
        dispatch(getRoles(entity)) // Fetch user roles if needed
        .unwrap()
        .then(() => {
          window.location.href = "/";
        })
      })
      .catch((err) => {
        console.log(err)
        Swal.fire("", err.response.data, "error", "OK");
      })
      .finally(() => {
        setLoading(false); // <-- End loading
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <>
    {loading && (
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color="#4fa94d"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
        }}
      />
    )}
    <Container style={{ flex: 1, maxWidth: "320px" }} className="ContainerContentLogin">
      <div className="TitleContainer">
        {/* <h5 className="TitleLabel">Site Leave Application</h5> */}
        <h5 className="TitleLabel">
          Site <br />
          Leave <br />
          Application
        </h5>
        <img src={lockIcon} alt="Lock" className="LockIcon" />
      </div>

      <div className="FormControlContainer">
        <div className="FormControlWrapper">
          <Form.Control
            name="username"
            type="text"
            placeholder="Username"
            value={username}
            onChange={handleChangeForm}
            onKeyPress={handleKeyPress}
          />
        </div>
      </div>

      <div className="FormControlContainer">
        <div className="FormControlWrapper">
          <Form.Control
            name="password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={handleChangeForm}
            onKeyPress={handleKeyPress}
          />
        </div>
      </div>

      <div className="FormControlContainer">
        <div className="FormControlWrapper">
          <Button type="button" className="BtnLogin" onClick={handleLogin}>
            Login
          </Button>
        </div>
      </div>

      <div className="FormControlContainer">
        <div className="FormControlWrapper">
          <p 
            className="ForgotText" 
            onClick={handleForgotPassword} 
            style={{ color: "white", fontSize: "13px", cursor: "pointer", textAlign: "center", marginTop: "20px" }}
          >
            Forgot your email or password?
          </p>
        </div>
      </div>
    </Container>
    </>
  );
};

export default Login;
